type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

export const MASTER_NOTIFICATION_PREFERENCE_HEADERS: Header[] = [
  {
    key: "srNo",
    label: "Sr No.",
    style: { width: "5%" },
  },
  {
    key: "roleName",
    label: "User Role",
    style: { width: "20%" },
  },
  {
    key: "isEmailNotification",
    label: "Email Notification",
    style: { width: "15%" },
  },
  {
    key: "isSmsNotification",
    label: "SMS Notification",
    style: { width: "15%" },
  },
  {
    key: "isInAppNotification",
    label: "In-App Notification",
    style: { width: "15%" },
  },

  {
    key: "lastUploadedBy",
    label: "Last Updated By",
    style: { width: "15%" },
  },
  {
    key: "lastUploadedOn",
    label: "Last Updated On",
    style: { width: "15%" },
  },
];
